import React, { useState } from 'react';
import Logo from '../../logos/storage-sprint.png';
import backButtonImage from '../static/images/Cancel.png';
import { useNavigate } from "react-router-dom";
import { Helmet } from 'react-helmet';
import { saveSupportMessage } from '../../Services/ApiCallsServices/SupportApi';

const StartChat = () => {
    const [messages, setMessages] = useState([]);
    const [newMessage, setNewMessage] = useState('');
    const navigate = useNavigate();

    const handleSendMessage = async () => {
        if (newMessage.trim()) {
            const newMsg = { type: 'right', text: newMessage };
            setMessages([...messages, newMsg]);
            setNewMessage('');

            try {
                await saveSupportMessage(newMsg);
            } catch (error) {
                console.error('Error saving message:', error);
            }
        }
    };

    const handleBack = () => {
        navigate(-1);
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSendMessage();
        }
    };

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col">
            <Helmet>
                <title>Support chat - Storage Sprint</title>
            </Helmet>
            
            {/* Header with back button */}
            <div className="bg-white shadow-sm py-4 px-6 flex items-center">
                <button 
                    onClick={handleBack}
                    className="p-2 rounded-full hover:bg-gray-100 transition"
                >
                    <img src={backButtonImage} alt="Back" className="w-5 h-5" />
                </button>
                <h1 className="text-xl font-semibold text-gray-800 ml-4">Support Chat</h1>
            </div>

            {/* Main chat container */}
            <div className="flex-1 flex flex-col max-w-3xl w-full mx-auto p-4">
                {/* Logo and header */}
                <div className="flex flex-col items-center mb-6">
                    <img 
                        src={Logo} 
                        alt="Storage Sprint Logo" 
                        className="w-20 h-20 object-contain mb-4" 
                    />
                    <h2 className="text-2xl font-bold text-gray-800 text-center">
                        Leave a Message for Support
                    </h2>
                    <p className="text-gray-500 mt-2 text-center">
                        Our team will get back to you as soon as possible
                    </p>
                </div>

                {/* Messages container */}
                <div className="flex-1 overflow-y-auto mb-6 space-y-4">
                    {messages.length === 0 ? (
                        <div className="text-center text-gray-500 py-8">
                            <p>No messages yet. Start the conversation!</p>
                        </div>
                    ) : (
                        messages.map((msg, index) => (
                            <div 
                                key={index} 
                                className={`flex ${msg.type === 'right' ? 'justify-end' : 'justify-start'}`}
                            >
                                <div 
                                    className={`max-w-xs md:max-w-md rounded-lg px-4 py-2 ${
                                        msg.type === 'right' 
                                            ? 'bg-yellow-400 text-gray-800 rounded-br-none'
                                            : 'bg-gray-200 text-gray-800 rounded-bl-none'
                                    }`}
                                >
                                    <p>{msg.text}</p>
                                </div>
                            </div>
                        ))
                    )}
                </div>

                {/* Message input */}
                <div className="bg-white rounded-lg shadow-md p-4">
                    <div className="flex space-x-2">
                        <input
                            type="text"
                            value={newMessage}
                            placeholder="Type your message..."
                            onChange={(e) => setNewMessage(e.target.value)}
                            onKeyPress={handleKeyPress}
                            className="flex-1 border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-yellow-400 focus:border-yellow-400 transition"
                        />
                        <button 
                            onClick={handleSendMessage}
                            disabled={!newMessage.trim()}
                            className="px-4 py-2 bg-yellow-400 text-gray-800 font-semibold rounded-lg hover:bg-yellow-500 transition disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            Send
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StartChat;